import { render, staticRenderFns } from "./ResponsiveIframe.vue?vue&type=template&id=31714bac"
import script from "./ResponsiveIframe.vue?vue&type=script&lang=js"
export * from "./ResponsiveIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports